// Module
var code = "<button class=\"btn btn-sm btn-primary btn-launch\" type=\"button\" ng-click=\"$ctrl.editor.launch()\" ng-disabled=\"$ctrl.disabled\"> <i class=\"fa fa-play\" ng-if=\"!$ctrl.loading\"></i> <i class=\"fa fa-refresh fa-spin\" ng-if=\"$ctrl.loading\"></i> <span class=\"lib\" translate>common.run</span> </button> ";
// Exports
export default code;